import { Link, useLocation } from "react-router-dom";
import { MailCheck } from "lucide-react";
import PublicShell from "@/components/PublicShell";
import { cardCls } from "@/lib/creators";

export default function CreatorThankYou() {
  const handle = useLocation().state?.handle;
  return (
    <PublicShell testId="creator-thank-you">
      <div className="px-6 pt-10 max-w-xl lg:mx-auto fade-up">
        <div className={`${cardCls} text-center py-10`}>
          <MailCheck size={40} className="gold-text mx-auto mb-4" />
          <h1 className="text-3xl font-light mb-3">Application received</h1>
          <p className="text-base text-[#D6D0C5]">Thank you{handle ? `, @${handle}` : ""}. We've emailed you a confirmation and will reply within a few days.</p>
          <p className="text-sm text-[#A7B0C0] mt-4">Once approved, your page goes live and you can sign in to your dashboard with a link we email you.</p>
          <Link to="/" data-testid="thank-you-home" className="inline-block mt-6 gold-text underline underline-offset-4">Back to today's horoscopes</Link>
        </div>
      </div>
    </PublicShell>
  );
}
